import { Button, Checkbox, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { useState } from 'react';
import { getMarketingUrl } from 'utils/app-urls';
import AlertImage from '../../assets/Alert.svg';
import { tradeSharedContent } from '../../tradeShared.content';
import { content } from './CryptoDisclosureModal.content';

const CryptoDisclosureModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: (dontShowAgain: boolean) => void;
}) => {
  const localizedContent = useContent(content, tradeSharedContent);
  const [isChecked, setIsChecked] = useState(false);
  const legalDocumentsUrl = `${getMarketingUrl()}/legal/terms-of-service`;

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={() => onClose?.(false)}
      backgroundColor="#0C1C2C">
      <div className="flex flex-col items-center w-full my-4 px-4  gap-6">
        <img src={AlertImage} />
        <Heading level={4} className="text-center">
          {localizedContent.cryptoIsVolatile}
        </Heading>
        <Typography
          weight="medium"
          size="large"
          className="text-gray text-center">
          {localizedContent.riskDisclosureWarning.intro}{' '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.riskDisclosureWarning.orderPolicy}
          </a>
          {', '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.riskDisclosureWarning.generalRisk}
          </a>{' '}
          {localizedContent.and}{' '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.riskDisclosureWarning.cryptoRisk}
          </a>
        </Typography>

        <div className="flex flex-col w-full items-center mt-10">
          <Checkbox
            label={localizedContent.dontShowAgain}
            onChange={checked => setIsChecked(checked)}
          />
          <Button
            color="primary"
            size="large"
            onPress={() => onClose?.(isChecked)}
            text={localizedContent.iUnderstand}
            className="mt-6 w-full"
          />
        </div>
      </div>
    </DialogOrBottomSheet>
  );
};

export default CryptoDisclosureModal;
